import store from '../store/store';
import createEditorViewState from 'owa-editor/lib/utils/createEditorViewState';
import { action, select } from 'satcheljs/lib/legacy';
import { getUserConfiguration } from 'owa-session-store';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(action('discardSignatureOption')(function discardSignatureOption(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    optionState.editorViewState = createEditorViewState(userOptions.SignatureHtml /*content*/, false /*isDirty*/);
    optionState.signNewMails = null;
    optionState.signReplies = null;
}));
//# sourceMappingURL=discardSignatureOption.js.map